// grid.js — version complète, propre et découplée
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { startArticleTransition } from './article-transition';   // ← même dossier → ./

// ────────────────────────────────────────────────
// PARALLAX INCHANGÉ (comme tu l'as demandé explicitement)
// ────────────────────────────────────────────────
export const initGridParallax = () => {
    const cols    = document.querySelectorAll('[data-parallax-col]');
    const section = document.querySelector('#projects-grid');
    if (!cols.length || !section) return;

    gsap.set(cols, { y: 0 });

    cols.forEach((col) => {
        const index = parseInt(col.dataset.parallaxCol);
        const dir   = index % 2 === 0 ? -150 : 150;

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: "#projects-grid",
                scroller: document.body,
                start: "top top",
                end: "bottom 100%",
                scrub: 1.5,
                invalidateOnRefresh: true,
            }
        });

        tl
          .to(col, { y: dir, ease: "none", duration: 1 })
          .to(col, { y: 0,   ease: "none", duration: 1 });
    });
};



// ────────────────────────────────────────────────
// CLICS → maintenant découplés via article-transition.js
// ────────────────────────────────────────────────
export const initGridClick = () => {
    document.querySelectorAll('#grid-wrapper article[data-transition="article"]').forEach(article => {


        article.querySelectorAll('a').forEach(link => {
            link.addEventListener('click', (e) => e.preventDefault());
        });

        article.addEventListener('click', (e) => {
            e.preventDefault();
            startArticleTransition(article);  // ← appel propre, sans Barba ici
        });
    });
};

export const initLatestGridClick = () => {
    document.querySelectorAll('#latest-grid article[data-transition="article"]').forEach(article => {
        article.addEventListener('click', () => {
            startArticleTransition(article);  // ← appel propre, sans Barba ici
        });
    });
};